import React from "react";
import LandingPageLayout from "@/components/LandingPageLayout";

export default function VipLimousineService() {
  return (
    <LandingPageLayout translationKey="vipService" />
  );
}
